import React, { Component } from 'react';
import {Redirect} from 'react-router-dom' ;
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink} from 'reactstrap';
import SubTitle from 'components/FacilityRequestComponents/ResourceComponents/SubTitle';
import MyRequests from 'components/FacilityRequestComponents/Maintenance/MyRequests';
import AllRequests from 'components/FacilityRequestComponents/Maintenance/AllRequests';
import styles from './maintenance.module.css';


export default class Maintenance extends Component {

    constructor(props) {
        super(props);
        this.state = {
            navigateToCreateMaintenance_state: false,
            activeTab: '1'
        };
        this.navigateToCreateMaintenance = this.navigateToCreateMaintenance.bind(this);  
        this.toggle = this.toggle.bind(this);
    }

    navigateToCreateMaintenance(){ 
        this.setState({navigateToCreateMaintenance_state:true})
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
        this.setState({
            activeTab: tab
        });
        }
    }

    render() {

        //Navigate or redirect to create maintenance page
        if(this.state.navigateToCreateMaintenance_state){
            return <Redirect to={{ pathname: '/FacilityManagement/createMaintenance' }} />
        }

        return (
            <div>
                <div className={styles.titleSection}>
                      <SubTitle text={"Maintenance"} /> 
                        <button onClick={this.navigateToCreateMaintenance}  className={styles.add_navigate_Button}>+ MAINTENANCE REQUEST</button>
                </div>

            <div className={styles.whiteContainer}>
                     <Nav tabs >
                        <NavItem  className={styles.nav_item_first}>
                         <NavLink   className={classnames({ active: this.state.activeTab === '1' }, [this.state.activeTab] === '1'? [styles.active_tab] :[styles.deactive_tab])} onClick={() => { this.toggle('1'); }}> My Requests </NavLink>  </NavItem>
                        <NavItem  className={styles.nav_item_second}> <NavLink  className={classnames({ active: this.state.activeTab === '2' }, [this.state.activeTab] === '2'? [styles.active_tab] :[styles.deactive_tab])}  onClick={() => { this.toggle('2'); }} >  All Requests </NavLink>  </NavItem>
                     </Nav>
                    
                    <TabContent activeTab={this.state.activeTab} className={styles.tabcontent}style={{maxHeight:"1000px !important"}} >
                            <TabPane tabId="1" className={styles.tabcontentcontainer} style={{maxHeight:"1000px !important"}}> <MyRequests/> </TabPane>
                            <TabPane tabId="2" className={styles.tabcontentcontainer} style={{maxHeight:"1000px !important"}}> <AllRequests/> </TabPane>
                    </TabContent>
               
            </div>
        </div>
        );
    }
}

